import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["setNumLoading", "setError", "objPK", "objType", "invite", "csrftoken", "isAuthenticated", "shareOnHide", "refreshData"];
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { withResponseErrorHandling } from './withResponseErrorHandling';

// Display invited users in this component and also update those users
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var MakeOwner = function MakeOwner(_ref) {
  var setNumLoading = _ref.setNumLoading,
    setError = _ref.setError,
    objPK = _ref.objPK,
    objType = _ref.objType,
    invite = _ref.invite,
    csrftoken = _ref.csrftoken,
    isAuthenticated = _ref.isAuthenticated,
    shareOnHide = _ref.shareOnHide,
    refreshData = _ref.refreshData,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!props.show) {
    return null;
  }
  var makeInvitedUserOwner = function makeInvitedUserOwner() {
    props.onHide();
    withResponseErrorHandling(fetch("/api/v2/change/object/owner/", {
      headers: _objectSpread(_objectSpread({}, isAuthenticated ? {
        'X-CSRFToken': csrftoken
      } : {}), {}, {
        'Content-Type': 'application/json'
      }),
      method: "POST",
      body: JSON.stringify({
        new_owner_pk: invite.user_pk,
        obj_pk: objPK,
        obj_type: objType
      })
    }).then(function (res) {
      return res.json();
    }), 'changing owner', setNumLoading, setError).then(function (response) {
      if (response && (response.status === "OK" || response.status === 200 || response.status === true)) {
        refreshData();
      }
    });
  };
  var name = invite.email === invite.user_name ? /*#__PURE__*/_jsx("span", {
    className: "make-owner-name-as-email",
    children: invite.email
  }) : invite.user_name && invite.email ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: "make-owner-name",
      children: invite.user_name
    }), /*#__PURE__*/_jsx("span", {
      className: "make-owner-email",
      children: invite.email
    })]
  }) : /*#__PURE__*/_jsx("span", {
    className: "maker-owner-name-as-email",
    children: invite.user_name || invite.email
  });
  return /*#__PURE__*/_jsxs(Modal, _objectSpread(_objectSpread({}, props), {}, {
    size: "sm",
    centered: true,
    backdrop: "static",
    children: [/*#__PURE__*/_jsxs(Modal.Body, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsxs("b", {
          children: ["Make ", name, " the new owner?"]
        })
      }), /*#__PURE__*/_jsx("p", {
        children: "The new owner will be notified and will gain the ability to remove you or lower your access level"
      })]
    }), /*#__PURE__*/_jsxs(Modal.Footer, {
      children: [/*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        onClick: function onClick() {
          return props.onHide();
        },
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: function onClick() {
          return makeInvitedUserOwner();
        },
        children: "Confirm make owner"
      })]
    })]
  }));
};
export default MakeOwner;